// extracted by mini-css-extract-plugin
export default {"input-field":"InputName_input-field__reLFj","btn":"InputName_btn__h2ZjI"};